import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { LoteAgendamento } from "../../../../services/LoteAgendamento";
import { TipoServicoLote } from "../../../../types/loteAgendamento";

export const useDownloadModeloPlanilha = () => {
  return useMutation({
    mutationFn: (tipoServico: TipoServicoLote) =>
      LoteAgendamento.downloadModelo(tipoServico),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
